import React from "react";

import VendorList from "./vendor/list";
import VendorShow from "./vendor/show";

import ClientList from "./client/list";
import ClientShow from "./client/show";
import ClientShowPurchaseOrder from "./client/showPurchaseOrder";
import ClientUncompensated from "./client/uncompensated";
import ClientPurchaseOrder from "./client/purchaseOrder";
import ClientAssignJob from "./client/assignJob";

import { Switch, Route } from "react-router-dom";

import {
    LAYOUT_FINANCE_INVOICE_VENDOR_LIST,
    LAYOUT_FINANCE_INVOICE_VENDOR_SHOW,
    LAYOUT_FINANCE_INVOICE_CLIENT_LIST,
    LAYOUT_FINANCE_INVOICE_CLIENT_SHOW,
    LAYOUT_FINANCE_INVOICE_CLIENT_SHOW_PURCHASE_ORDER,
    LAYOUT_FINANCE_INVOICE_CLIENT_FROM_UNCOMPENSATED_JOBS,
    LAYOUT_FINANCE_INVOICE_CLIENT_FROM_PURCHASE_ORDER,
    LAYOUT_FINANCE_INVOICE_CLIENT_ASSIGN_JOB,
    LAYOUT_FINANCE_INVOICE_CLIENT_ADD_JOB,
} from "../navigation";

const Router = (props) => (
    <Switch>
        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_ASSIGN_JOB(
                ":invoiceId",
                ":invoiceDetailPurchaseOrderId",
                ":name",
                ":clientId"
            )}
            render={(routeProps) => <ClientAssignJob {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_ADD_JOB(":invoiceId", ":clientId")}
            render={(routeProps) => <ClientAssignJob add {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_LIST}
            render={(routeProps) => <ClientList {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_SHOW(":id")}
            render={(routeProps) => <ClientShow {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_SHOW_PURCHASE_ORDER(":id")}
            render={(routeProps) => <ClientShowPurchaseOrder {...props} {...routeProps} />}
        />

        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_FROM_UNCOMPENSATED_JOBS}
            render={(routeProps) => <ClientUncompensated {...props} {...routeProps} />}
        />

        <Route
            path={LAYOUT_FINANCE_INVOICE_CLIENT_FROM_PURCHASE_ORDER}
            render={(routeProps) => <ClientPurchaseOrder {...props} {...routeProps} />}
        />

        <Route
            path={LAYOUT_FINANCE_INVOICE_VENDOR_LIST}
            render={(routeProps) => <VendorList {...props} {...routeProps} />}
        />

        <Route
            path={LAYOUT_FINANCE_INVOICE_VENDOR_SHOW(":id")}
            render={(routeProps) => <VendorShow {...props} {...routeProps} />}
        />
    </Switch>
);

export default Router;
